/**
 * 组件挂载点改变
 * this.mount 更改组件挂载节点
 * 可在跟节点 v-show="activated" 使得组件离开后隐藏
 * */

export default {
  data() {
    return {
      activated: true // 是否活动
    }
  },

  deactivated() {
    this.activated = false
  },

  activated() {
    this.activated = true
  },

  mounted() {
    const cont = document.querySelector(this.mount)
    if (cont) {
      cont.appendChild(this.$el)
    }
  },

  destroyed() {
    let $el = this.$el
    if ($el.parentElement) {
      $el.parentElement.removeChild($el)
    }
  }
}
